import React, {Component, Fragment } from 'react';
import axios from 'axios';
import Helmet from 'react-helmet';

const initialState = {
  id: '',
  mailAddress: '',
  password: '',
  rePassword: '',
  otp: '',
  onetimeTid: '',
  maskmail: '',
  mailCheck: false,
  complete: false,
  errorMap: null,
  loading : false,
  showPwd: false
}

class PwdReset extends Component {
  state=initialState;

  // 初期表示処理
  componentDidMount() {
  }

  // パスワードリセット画面[変更]ボタン押下時処理
  pwdReset = () => {

    const { password, rePassword, otp, onetimeTid } = this.state;

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // バリデーションチェックを行う
    if (password === '') {
      this.setState({ errorMap: { ERROR: messageList.pwdReset.M020_errorMessage001, errorId: ['password'] }});  
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    if (password !== rePassword) {
      this.setState({ errorMap: { ERROR: messageList.pwdReset.M022_errorMessage003, errorId: ['password', 'rePassword'] }, password: '', rePassword: ''});
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    if (otp === '') {
      this.setState({ errorMap: { ERROR: messageList.pwdReset.M021_errorMessage002, errorId: ['otp'] }});
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    try {
      // ローディング開始
      this.setState({ loading: true });

      // 3Keyパスワード再設定API
      axios
        .put( process.env.REACT_APP_URL_CO_SC_API_PASSWORD_RESET,
          {
          newPassword: password,
          onetimePassword: otp,
          onetimeTid: onetimeTid
          },
          {headers: {'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                     'Cache-Control': 'no-store',
                     'Pragma': 'no-cache'}}
        )
        .then( response => {
          this.setState({ 
                          errorMap: null, 
                          complete: true,
                          loading: false
                        });
        })
        .catch( error => {
          if ( error.response ) {
            if ( error.response.status === 400 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdReset.M023_errorMessage004 },
                loading: false, password: '', rePassword: '', otp: ''
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            else if ( error.response.status === 401 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdReset.M023_errorMessage004 },
                loading: false, password: '', rePassword: '', otp: ''
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            else if ( error.response.status === 403 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdReset.M023_errorMessage004 },
                loading: false, password: '', rePassword: '', otp: ''
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            else if ( error.response.status === 500 ) {

              // システムエラー画面表示
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
              });
            }
            else {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdReset.M023_errorMessage004 },
                loading: false, password: '', rePassword: '', otp: ''
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
          }
          else {
            this.setState({ errorMap:
              { ERROR: messageList.pwdReset.M023_errorMessage004 },
              loading: false, password: '', rePassword: '', otp: ''
            });
            // エラーメッセージ表示領域に遷移する
            window.location="#JS_error";
          }
        })
    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
        { ERROR: messageList.pwdReset.M023_errorMessage004 },
        loading: false, password: '', rePassword: '', otp: ''
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";

    } finally {
    }
  }

  // パスワードリセット開始画面[再設定する]ボタン押下時処理
  mailCheck = () => {

    const { id, mailAddress } = this.state;

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // バリデーションチェックを行う
    if (id === '') {
      this.setState({ errorMap: { ERROR: messageList.pwdResetStart.M016_errorMessage001, errorId: ['id'] }
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    if (mailAddress === '') {
      this.setState({ errorMap: { ERROR: messageList.pwdResetStart.M017_errorMessage002, errorId: ['mailAddress'] }
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    try {

      // ローディング開始
      this.setState({ loading: true });

      // 3Keyパスワード再設定メール送信要求API
      axios
        .post( process.env.REACT_APP_URL_CO_SC_API_MAIL_PASSWORD_RESET,
          {
            id: id,
            mailaddress: mailAddress,
            onetimeMailType: process.env.REACT_APP_ONE_TIME_MAIL
          },
          {headers: {'accept-language': window.changeLang(sessionStorage.getItem("lang")),
                     'Cache-Control': 'no-store',
                     'Pragma': 'no-cache'}}
        )
      .then( response => {
        if ( response.data.maskmail || response.data.maskphonenumber) {
          this.setState({ errorMap: null,
            onetimeTid: response.data.onetimeTid,
            maskmail: response.data.maskmail,
            mailCheck: true,
            password: '',
            rePassword: '',
            otp: '',
            loading: false
            });
        }
        else {
          this.setState({ errorMap:
            { ERROR: messageList.pwdResetStart.M020_errorMessage004 },
            loading: false
          });
          // エラーメッセージ表示領域に遷移する
          window.location="#JS_error";
        }
      })
        .catch( error => {
          if ( error.response ) {
            if ( error.response.status === 400 ) {

              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdResetStart.M018_errorMessage003 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            else if ( error.response.status === 500 ) {

              // エラー画面に遷移し、処理を終了する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
              });
            }
            else {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pwdResetStart.M018_errorMessage003 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
          }
          else {
            this.setState({ errorMap:
              { ERROR: messageList.pwdResetStart.M018_errorMessage003 },
              loading: false
            });           
            // エラーメッセージ表示領域に遷移する
            window.location="#JS_error";
          }
        });

    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
        { ERROR: messageList.pwdResetStart.M018_errorMessage003 },
        loading: false
      });     
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";

    } finally {
    }
  }

  // パスワード表示切り替え処理
  swhichPwdShow = e => {
    this.setState({ showPwd: e.currentTarget.checked });
  }

  // 画面をクローズする
  close = e => {
    window.open('about:blank','_self').close();
  }

  // パスワードリセット開始画面へ戻る処理
  beforeMailCheck = () => {
    // メールチェックフラグ設定
    this.setState({ mailCheck: false, errorMap: null }, () => {

      // 画面再描画
      this.forceUpdate();
    })
  }

  handleChange = e => {
    this.setState({ [e.currentTarget.name]: e.currentTarget.value.trim() });
  }

  componentDidUpdate(prevProps,prevState) {
    if (prevState.mailCheck !== this.state.mailCheck && this.state.mailCheck){
      if ("OTPCredential" in window) {
        const ac = new AbortController();
        navigator.credentials
          .get({
            otp: { transport: ["sms"] },
            signal: ac.signal,
          })
          .then((otp) => {
            this.setState({ otp : otp.code });
          })
          .catch((err) => {
          });
      }
    }
  }

  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // パスワードリセット完了画面
    if (this.state.complete){

      // パスワードリセット完了画面表示
      return (
        <section>
          <Helmet
            title={messageList.pwdResetCompletion.browserTitle} >
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="hdg-l1">
            <h1 className="hdg-l1_txt">{messageList.pwdResetCompletion.pageTitle}</h1>
          </div>

          <div id="JS_error">
          { // エラーメッセージ表示
            (this.state.errorMap && this.state.errorMap.ERROR) &&
            <div className="panel-attention">
              <h2 className="panel-attention_hdg">
                <span className="panel-attention_icon">
                  <img src={`${process.env.PUBLIC_URL}/img/icon_error.svg`} alt={messageList.pwdReset.errorAlt}/>
                </span>{messageList.pwdReset.errorTitle}
              </h2>
              <p>{this.state.errorMap.ERROR}</p>
            </div>/* /panel-attention */
          }
          </div>

          {/* 操作ボタン表示部 */}
          <div className="btn-wrap">
            <button type="button" name="__dummy__" className="btn-back" onClick={this.close}>{messageList.pwdResetCompletion.buttonClose}</button>
          </div>

          {/* ご案内 */}
          <div className="hdg-guide">
            <h2 className="hdg-guide_txt">{messageList.pwdResetCompletion.noticeTitle}</h2>
          </div>
          <ul className="list">
            <li>{messageList.pwdResetCompletion.notice001}</li>
          </ul>
        </section>
      );
    }

    // パスワードリセット画面
    else if (this.state.mailCheck) {  

      // 画面に表示するメッセージを作成する
      let maskMessage = "";
      if(this.state.maskmail){
        maskMessage = messageList.pwdReset.guideMessage001 + this.state.maskmail + messageList.pwdReset.guideMessage002;
      }else{
        maskMessage = messageList.pwdReset.guideMessage001 + messageList.pwdReset.guideMessage002;
      }

      // パスワードリセット画面表示
      return (
        <section>
          <Helmet
            title={messageList.pwdReset.browserTitle} >
          </Helmet>

          { // Loadingモーダル表示
            this.state.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/img/load.gif`} alt="loading"/></div>
          }

          {/* 画面タイトル表示部 */}
          <div className="hdg-l1">
            <h1 className="hdg-l1_txt">{messageList.pwdReset.pageTitle}</h1>
          </div>

          {/* ガイドメッセージ表示部 */}
          <p>{maskMessage}<br></br>
            {messageList.pwdReset.guideMessage003}
          </p>
          <a href="https://www.jal.co.jp/jalonline/contact/" className="link-txt _other" target="otherwindow">
            <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageList.pwdReset.guideNewWindow} className="icon-blank"/>
            {messageList.pwdReset.linkOnlinedesk}
          </a>

          <div id="JS_error">
          { // エラーメッセージ表示
            (this.state.errorMap && this.state.errorMap.ERROR) &&
            <div className="panel-attention">
              <h2 className="panel-attention_hdg">
                <span className="panel-attention_icon">
                  <img src={`${process.env.PUBLIC_URL}/img/icon_error.svg`} alt={messageList.pwdReset.errorAlt}/>
                </span>{messageList.pwdReset.errorTitle}
              </h2>
              <p>{this.state.errorMap.ERROR}</p>
            </div>/* /panel-attention */
          }
          </div>

          <div className="panel-form">
            <div className="panel-form-inner">
              <div className="panel-form-inner_item">
                <form name="dummy" id="JS_jmbForm">

                  {/* 画面項目表示部 */}             
                  <div className="panel-form-inner_parts">
                    {/* 新パスワード */}
                    <p className="form-label"><label htmlFor="LA_input-password-01">{messageList.pwdReset.itemNewPassword}</label></p>
                    <p className="mb-form-label">{messageList.pwdReset.guideMessage004}</p>
                    <input type={ this.state.showPwd ? "text" : "password"} id="LA_input-password-01" 
                      className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('password') ? 
                      "form-txt js-form-validate-blank JS_jmbNo is-blank is-error" : "form-txt js-form-validate-blank JS_jmbNo is-blank"} 
                      maxLength="256" placeholder="" 
                      aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('password') ? "true" : "false"} 
                      name="password" value={this.state.password} onChange={this.handleChange}/>

                    {/* 新パスワードの再入力 */}
                    <p className="form-label"><label htmlFor="LA_input-password-02">{messageList.pwdReset.itemReNewPassword}</label></p>
                    <input type={ this.state.showPwd ? "text" : "password"} id="LA_input-password-02" 
                      className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('rePassword') ? 
                      "form-txt js-form-validate-blank JS_jmbPass is-blank is-error" : "form-txt js-form-validate-blank JS_jmbPass is-blank"} 
                      maxLength="256" placeholder="" 
                      aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('rePassword') ? "true" : "false"} 
                      name="rePassword" value={this.state.rePassword} onChange={this.handleChange}/>

                    {/* パスワードを表示する */}
                    <span className="form-checkbox _block">
                      <input type="checkbox" id="LA_form-checkbox-01" name="__dummy__" aria-controls="LA_input-password-01 LA_input-password-02" onChange={this.swhichPwdShow}/>
                      <label htmlFor="LA_form-checkbox-01" className="form-checkbox_item is-blank">{messageList.pwdReset.guideMessage005}</label>
                    </span>
                  </div>

                  {/* ワンタイムパスワード */}
                  <div className="panel-form-inner_parts">
                    <p className="form-label"><label htmlFor="LA_input-password-03">{messageList.pwdReset.itemOtp}</label></p>
                    <input type="tel" id="LA_input-password-03" 
                      className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('otp') ? 
                      "form-txt js-form-validate-blank JS_jmbPass is-blank is-error" : "form-txt js-form-validate-blank JS_jmbPass is-blank"} 
                      maxLength="6" placeholder="" 
                      aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('otp') ? "true" : "false"} 
                      name="otp" value={this.state.otp} onChange={this.handleChange} autoComplete="one-time-code"/>
                  </div>

                  {/* 操作ボタン表示部 */}
                  <div className="btn-wrap">
                    <div className="lyt-btn-line">
                      <button type="button" name="__dummy__" className="btn-back _small" onClick={this.beforeMailCheck}>{messageList.pwdReset.buttonBack}</button>
                      <button type="button" name="__dummy__" className="btn _small" onClick={this.pwdReset}>{messageList.pwdReset.buttonChange}</button>
                    </div>
                  </div>

                </form>
              </div> {/* /panel-form-inner_item */}
            </div> {/* /panel-form-inner */}
          </div>

          {/* ご案内 */}
          <div className="hdg-guide">
            <h2 className="hdg-guide_txt">{messageList.pwdReset.noticeTitle}</h2>
          </div>
          <ul className="list">
            <li>{messageList.pwdReset.notice001}<br></br>
              {messageList.pwdReset.notice002}
            </li>
          </ul>
        </section>
      );
    }

    // パスワードリセット開始画面表示
    else {
      return (
        <section>
          <Helmet
            title={messageList.pwdResetStart.browserTitle} >
          </Helmet>

          { // Loadingモーダル表示
            this.state.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/img/load.gif`} alt="loading"/></div>
          }

          {/* 画面タイトル表示部 */}
          <div className="hdg-l1">
            <h1 className="hdg-l1_txt">{messageList.pwdResetStart.pageTitle}</h1>
          </div>

          {/* ガイドメッセージ表示部 */}
          <p>{messageList.pwdResetStart.guideMessage001}<br></br>
            {messageList.pwdResetStart.guideMessage002}<br></br>
            {messageList.pwdResetStart.guideMessage003}<br></br>
            {messageList.pwdResetStart.guideMessage004}
          </p>

          <div id="JS_error">
          { // エラーメッセージ表示
            (this.state.errorMap && this.state.errorMap.ERROR) &&
            <div className="panel-attention">
              <h2 className="panel-attention_hdg">
                <span className="panel-attention_icon">
                  <img src={`${process.env.PUBLIC_URL}/img/icon_error.svg`} alt={messageList.pwdResetStart.errorAlt}/>
                </span>{messageList.pwdResetStart.errorTitle}
              </h2>
              <p>{this.state.errorMap.ERROR}</p>
            </div>/* /panel-attention */
          }
          </div>

          <div className="panel-form">
            <div className="panel-form-inner">
              <div className="panel-form-inner_item">
              <form name="dummy" id="JS_jmbForm">

                {/* 画面項目表示部 */}
                {/* 管理者ID */}
                <div className="panel-form-inner_parts">
                  <p className="form-label"><label htmlFor="ID_input-number">{messageList.pwdResetStart.itemId}</label></p>
                  <input type="text" id="ID_input-number" 
                    className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('id') ? 
                    "form-txt js-form-validate-blank JS_jmbNo is-blank is-error" : "form-txt js-form-validate-blank JS_jmbNo is-blank"} 
                    name="id" value={this.state.id}
                    maxLength="9" placeholder="" 
                    aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('id') ? "true" : "false"} 
                    onChange={this.handleChange} onKeyDown = {e => {if (e.keyCode === 13) e.preventDefault();}}/>
                </div>

                {/* メールアドレス */}
                <div className="panel-form-inner_parts">
                  <p className="form-label"><label htmlFor="MAIL_input">{messageList.pwdResetStart.itemMailAddress}</label></p>
                  <input type="email" id="MAIL_input" 
                    className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('mailAddress') ? 
                    "form-txt js-form-validate-blank JS_jmbNo is-blank is-error" : "form-txt js-form-validate-blank JS_jmbNo is-blank"} 
                    name="mailAddress" value={this.state.mailAddress}
                    maxLength="256" placeholder="" 
                    aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('mailAddress') ? "true" : "false"} 
                    onChange={this.handleChange} onKeyDown = {e => {if (e.keyCode === 13) e.preventDefault();}}/>
                </div>

                {/* 操作ボタン表示部 */}
                <div className="btn-wrap">
                  <button type="button" name="__dummy__" className="btn" onClick={this.mailCheck}>{messageList.pwdResetStart.buttonReset}</button>
                </div>

                </form>
              </div> {/* /panel-form-inner_item */}
            </div> {/* /panel-form-inner */}
          </div>

          {/* 案内表示部 */}
          <div className="hdg-guide">
            <h2 className="hdg-guide_txt">{messageList.pwdResetStart.noticeTitle}</h2>
          </div>
          <ul className="list">           
            <li>{messageList.pwdResetStart.notice001}<br></br>
              {messageList.pwdResetStart.notice002}
            </li>
          </ul>
        </section>
      );
    }
  }
}

export default PwdReset